var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("app-display", {
            class:
              _vm.compararAforamentoImovel &&
              _vm.compararAforamentoImovel.mudouDenominacao
                ? "text"
                : "",
            attrs: { label: "Denominação:", content: _vm.imovel.denominacao }
          }),
          _c("app-display", {
            class:
              _vm.compararAforamentoImovel &&
              _vm.compararAforamentoImovel.mudouMunicipio
                ? "text"
                : "",
            attrs: {
              label: "Município:",
              content: _vm.imovel.municipio ? _vm.imovel.municipio.nome : ""
            }
          }),
          _c("app-display", {
            class:
              _vm.compararAforamentoImovel &&
              _vm.compararAforamentoImovel.mudouArea
                ? "text"
                : "",
            attrs: {
              label: "Área:",
              content: _vm.formatAreaHectare(_vm.imovel.area)
            }
          }),
          _c("info-matricula", { attrs: { imovel: _vm.imovel } }),
          _c(
            "app-collapse",
            { attrs: { title: "Dados do título" } },
            [
              _c("app-display", {
                class:
                  _vm.compararAforamentoImovel &&
                  _vm.compararAforamentoImovel.mudouNomeBeneficiarioTitulo
                    ? "text"
                    : "",
                attrs: {
                  label: "Nome do beneficiário:",
                  content: _vm.getValue(_vm.imovel.nomeBeneficiarioTitulo)
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b370cdde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b370cdde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/informacoesAforamento/InformacoesAforamentoImovel.vue
// module id = null
// module chunks = 